import { IconProps } from '../iconProps';

export const ClockPlus = ({ size = 24, fill = '' }: IconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={fill}
      stroke='currentColor'
      stroke-width='2'
      stroke-linecap='round'
      stroke-linejoin='round'
      className='lucide lucide-clock-plus-icon lucide-clock-plus'
    >
      <path d='M12 6v6l3.644 1.822' />
      <path d='M16 19h6' />
      <path d='M19 16v6' />
      <path d='M21.92 13.267a10 10 0 1 0-8.653 8.653' />
    </svg>
  );
};
